import { createStore } from '@stencil/store';

import wcShared from '@web-components/shared';

import {
  IReportingToolsPriority,
  IReportingToolsProject,
  IReportingToolsType,
} from '../models/typing';

export interface IReportingToolsFormStore {
  subject: string;
  description: string;
  subjectFeedback: string;
  descriptionFeedback: string;
  cerberusLink: string;
  project: IReportingToolsProject;
  projectsList: IReportingToolsProject[];
  recordedVideo: string;
  recordedVideoFile: File;
  printScreen: string;
  screenshot: File;
  hasScreenshot: boolean;
  isScreenshotLoading: boolean;
  priority: string;
  type: string;
  typeBug: IReportingToolsType[];
  bugPriorityLabel: string;
  bugPriorityValue: number;
  bugPriorityList: IReportingToolsPriority[];
  files: File[];
  totalFileSize: number;
  jaugeWidth: number;
  isPartner: boolean;
}

const { state } = createStore<IReportingToolsFormStore>({
  subject: null,
  description: null,
  subjectFeedback: null,
  descriptionFeedback: null,
  cerberusLink: null,
  project: null,
  projectsList: [],
  recordedVideo: null,
  recordedVideoFile: null,
  printScreen: null,
  screenshot: null,
  hasScreenshot: false,
  isScreenshotLoading: false,
  priority: null,
  type: null,
  typeBug: [
    {
      label: wcShared?.translate('Selectionner'),
      value: null,
    },
  ],
  bugPriorityLabel: null,
  bugPriorityValue: null,
  bugPriorityList: [
    {
      label: wcShared?.translate('Bas'),
      value: 1,
    },
    {
      label: wcShared?.translate('Normal'),
      value: 2,
    },
    {
      label: wcShared?.translate('Haut'),
      value: 3,
    },
    {
      label: wcShared?.translate('Urgent'),
      value: 4,
    },
    {
      label: wcShared?.translate('Immediat'),
      value: 5,
    },
  ],
  files: [],
  totalFileSize: 0,
  jaugeWidth: 0,
  isPartner: false,
});

export default state;
